var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { "no-padding": "" } }),
      _vm._v(" "),
      _c("Subheader", {
        attrs: {
          title: "Ecosurvey EDD File Ingestion Schemas",
          search: "ecosurvey EDD file ingestion schemas",
        },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  loading: _vm.isLoading,
                  headers: _vm.headers,
                  pagination: _vm.pagination,
                  items: _vm.schemas,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", [
                          _vm._v(_vm._s(props.item.SurveyProgramName)),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.SurveyType))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "", color: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewSchema(props.item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("edit"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.View")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "Ecosurvey ingestion schema for " +
                    _vm._s(_vm.selectedSchema.SurveyProgramName) +
                    " program " +
                    _vm._s(_vm.selectedSchema.SurveyType) +
                    " survey type"
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  {
                    staticClass: "tile-layout",
                    attrs: { row: "", wrap: "", "fill-height": "" },
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", md6: "", "pa-1": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            box: "",
                            label: "Survey Program Name",
                            disabled: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.selectedSchema.SurveyProgramName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectedSchema,
                                "SurveyProgramName",
                                $$v
                              )
                            },
                            expression: "selectedSchema.SurveyProgramName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", md6: "", "pa-1": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            box: "",
                            label: "Survey Type",
                            disabled: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.selectedSchema.SurveyType,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedSchema, "SurveyType", $$v)
                            },
                            expression: "selectedSchema.SurveyType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("EcosurveyIngestionSchemaColumn", {
                  attrs: {
                    columnName: `Date Column`,
                    columnData: _vm.selectedSchema.DateColumn,
                  },
                }),
                _vm._v(" "),
                _c("EcosurveyIngestionSchemaColumn", {
                  attrs: {
                    columnName: `Time Start Column`,
                    columnData: _vm.selectedSchema.TimeStartColumn,
                  },
                }),
                _vm._v(" "),
                _c("EcosurveyIngestionSchemaColumn", {
                  attrs: {
                    columnName: `Time End Column`,
                    columnData: _vm.selectedSchema.TimeEndColumn,
                  },
                }),
                _vm._v(" "),
                _c("EcosurveyIngestionSchemaColumn", {
                  attrs: {
                    columnName: `UTC Offset Column`,
                    columnData: _vm.selectedSchema.UTCOffsetColumn,
                  },
                }),
                _vm._v(" "),
                _c("EcosurveyIngestionSchemaColumn", {
                  attrs: {
                    columnName: `Survey Location Column`,
                    columnData: _vm.selectedSchema.SurveyLocationColumn,
                  },
                }),
                _vm._v(" "),
                _c("EcosurveyIngestionSchemaColumn", {
                  attrs: {
                    columnName: `Specimen Name Column`,
                    columnData: _vm.selectedSchema.SpecimenNameColumn,
                  },
                }),
                _vm._v(" "),
                _vm._l(
                  _vm.selectedSchema.LocationMetadataColumns,
                  function (optionColumn) {
                    return _c(
                      "v-layout",
                      { key: optionColumn.Header },
                      [
                        _c("EcosurveyIngestionSchemaColumn", {
                          attrs: { columnData: optionColumn },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.selectedSchema.SpecimenTaxonomyColumns,
                  function (optionColumn) {
                    return _c(
                      "v-layout",
                      { key: optionColumn.Header },
                      [
                        _c("EcosurveyIngestionSchemaColumn", {
                          attrs: { columnData: optionColumn },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.selectedSchema.SpecimenMetadataColumns,
                  function (optionColumn) {
                    return _c(
                      "v-layout",
                      { key: optionColumn.Header },
                      [
                        _c("EcosurveyIngestionSchemaColumn", {
                          attrs: { columnData: optionColumn },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.selectedSchema.SpecimenVariableDataColumns,
                  function (optionColumn) {
                    return _c(
                      "v-layout",
                      { key: optionColumn.Header },
                      [
                        _c("EcosurveyIngestionSchemaColumn", {
                          attrs: { columnData: optionColumn },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.selectedSchema.SpecimenVariableDataUnitColumns,
                  function (optionColumn) {
                    return _c(
                      "v-layout",
                      { key: optionColumn.Header },
                      [
                        _c("EcosurveyIngestionSchemaColumn", {
                          attrs: { columnData: optionColumn },
                        }),
                      ],
                      1
                    )
                  }
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  },
                  [_vm._v("Close")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.dialog,
          callback: function ($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }